import app from "@/main";

export class Toast {
  static plain(message) {
    this._showToast(message, "");
  }

  static info(message, time) {
    this._showToast(message, "info", time);
  }

  static success(message) {
    this._showToast(message, "success");
  }

  static warning(message) {
    this._showToast(message, "warning");
  }

  static error(message) {
    this._showToast(message, "danger");
  }

  static _showToast(message, color, time = 5000) {
    app.$notify({
      icon: "tim-icons icon-bell-55",
      type: color,
      timeout: time,
      message,
    });
  }
}
